module.exports = __webpack_public_path__ + "assets/21393bf89f999cfd2e4bfab8918e3282.svg";